import { Edit } from '@refinedev/mui'
import { Box, MenuItem, Select, TextField, Typography } from '@mui/material'
import { useForm } from '@refinedev/react-hook-form'
import Loading from '../../components/Loading'

export default function UsersEdit() {
  const {
    saveButtonProps,
    register,
    formState: { errors },
    refineCore: { query, formLoading },
    watch,
  } = useForm({
    refineCoreProps: {
      action: 'edit',
      resource: 'users',
      errorNotification: () => {
        return {
          message: 'Something went wrong when updating the user',
          description: 'An error occurred',
          type: 'error',
        }
      },
    },
  })

  if (formLoading) return <Loading />

  return (
    query?.data?.data && (
      <Edit saveButtonProps={saveButtonProps}>
        <Box
          component="form"
          sx={{ display: 'flex', flexDirection: 'column' }}
          autoComplete="off"
        >
          <Typography variant="body1">
            User's email: {query?.data?.data.email}
          </Typography>
          <TextField
            {...register('first_name', {
              required: 'This field is required',
            })}
            error={!!(errors as any)?.first_name}
            helperText={(errors as any)?.first_name?.message}
            margin="normal"
            fullWidth
            InputLabelProps={{ shrink: true }}
            type="text"
            label="First Name"
            name="first_name"
          />
          <TextField
            {...register('last_name')}
            margin="normal"
            fullWidth
            InputLabelProps={{ shrink: true }}
            type="text"
            label="Last Name"
            name="last_name"
          />
          <Select
            {...register('role', { required: 'This field is required' })}
            error={!!(errors as any)?.role}
            fullWidth
            type="text"
            label="Role"
            name="role"
            value={watch('role') || query?.data?.data.role}
          >
            <MenuItem value="admin">Admin</MenuItem>
            <MenuItem value="user">User</MenuItem>
          </Select>
        </Box>
      </Edit>
    )
  )
}
